module.exports = __webpack_public_path__ + "img/icon_mall.eab5785a.png";